export default {"src":"/_next/static/image/public/images/ic_video.45354c5dfdc40289b59e75f41fd322b1.svg","height":11,"width":16};